import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';

import api from '@API/api';
import { dialogTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';

export type AddMetricLibrary = {
  cometSql: string;
  name: string;
  workspaceId?: string;
};

const addMetricToLibrary = (data: AddMetricLibrary) => {
  return api.post(`mpm/v2/custom-metrics/library`, data);
};

export function useCustomMetricsLibraryAdd() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(
    (metricData: AddMetricLibrary) => addMetricToLibrary({ ...metricData }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['custom-metrics-library']);
        dispatch(
          alertsUtil.openSnackbarDialog(
            dialogTypes.SUCCESS_LIBRARY_METRIC_ADDED,
            'The metric was succesfully added to the library.'
          )
        );
      },
      onError: (error: AxiosError<{ msg?: string }>) => {
        dispatch(
          alertsUtil.openErrorDialog(
            dialogTypes.ERROR_LIBRARY_METRIC_ADDED,
            error?.response?.data?.msg || error.message
          )
        );
      }
    }
  );
}
